import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { PackageState } from './package-state';


export class PackageStateService  {
	public readonly _state = new BehaviorSubject<PackageState>({
		entries: [],
		loading: true,
		firstLoad: false
	});
	public readonly state$ = this._state.asObservable().map((state) => Object.assign({}, state));

	public get state(): PackageState {
		return {...this._state.getValue()};
	}

	public set state(state: PackageState) {
		this._state.next(state);
	}

	public setEntries(entries) {
		this.state = {
			...this.state,
			entries,
			loading: false
		};

		if (!this.state.firstLoad) {
			this._state.getValue().firstLoad = true;
		}
	}

	public setLoading(value) {
		this.state = {
			...this.state,
			loading: value
		};
	}

	public resetFirstLoad() {
		this.state = {
			...this.state,
			firstLoad: false
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/upgrade-or-downgrade/store/package-state.service.ts